import { ageConfirmCheck, ageConfirmClose } from './product'

/**
 * カートページ: 初期設定
 */
const cartPageInit = () => {
  if (document.querySelector('body').classList.contains('page-template-cart')) {
    /**
     * 0.5秒おきに #cart-delivery-datetime_section が取得できるまで待機、20秒経っても取得できない場合は処理を終了。
     */
    let count = 0
    const timer = setInterval(() => {
      if (document.querySelector('#cart-delivery-datetime_section_os2')) {
        clearInterval(timer)
        ampReplace()
      } else {
        count++
        if (count > 40) {
          clearInterval(timer)
          document.querySelector('.cart-amp-content').remove()
        }
      }
    }, 500)

    let ageConfirmItems = Array.from(document.querySelectorAll('[data-age-confirm-item]'))
    const checkoutButtons = Array.from(document.querySelectorAll('.cart-totals-checkout'))
    let cookieAgeConfirm = Boolean(Cookies.get('ageConfirm')) || false

    if (ageConfirmItems.length > 0) {
      cartAgeConfirmSetting()

      checkoutButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          cookieAgeConfirm = Boolean(Cookies.get('ageConfirm')) || false
          ageConfirmItems = Array.from(document.querySelectorAll('[data-age-confirm-item]'))

          if (ageConfirmItems.length > 0 && !cookieAgeConfirm) {
            e.preventDefault()
            document.querySelector('body').classList.add('is-age-confirm')
          }
        })
      })
    }
  }
}

/**
 * カートページ: .amp App 位置置き換え
 */
const ampReplace = () => {
  const ampDom = document.querySelector('#cart-delivery-datetime_section_os2')
  const ampWrapper = document.querySelector('.cart-amp-content')
  ampWrapper.appendChild(ampDom)
}

/**
 * 年齢確認モーダル設定
 */
const cartAgeConfirmSetting = () => {
  const body = document.querySelector('body')
  const input = document.querySelector('[name="birth_date"]')
  const confirmSubmit = document.querySelector('[data-age-confirm-anser]')
  const checkoutButtons = Array.from(document.querySelectorAll('.cart-totals-checkout'))

  input.addEventListener('change', (e) => {
    e.preventDefault()
    confirmSubmit.disabled = e.target.value !== '' ? false : true
    body.classList.remove('is-age-confirm-error')
  })

  // モーダル クローズ処理
  const ageConfirmCloses = Array.from(document.querySelectorAll('[data-age-confirm-close]'))
  ageConfirmCloses.forEach((close) => {
    close.addEventListener('click', (e) => ageConfirmClose())
  })

  confirmSubmit.addEventListener('click', (e) => {
    e.preventDefault()

    if (ageConfirmCheck()) {
      checkoutButtons[0].click()
      ageConfirmClose()
    }
  })
}

export { cartPageInit }
